//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';

import { RequestType } from '../../../types/enums/request-enums';

const GetRateLimitSummary = (params: any) =>
    request({
        url: ApiURL.Query.GetRateLimitSummary,
        method: RequestType.GET,
        params,
    });

const GetCountryLimitByPlatform = (params: any) =>
    request({
        url: ApiURL.Query.GetCountryLimitByPlatform,
        method: RequestType.GET,
        params,
    });

const GetCountryLimitHistory = (params: any) =>
    request({
        url: ApiURL.Query.GetCountryLimitHistory,
        method: RequestType.GET,
        params,
    });

const GetCountryLimit = (params: any) =>
    request({
        url: ApiURL.Query.GetCountryLimit,
        method: RequestType.GET,
        params,
    });

const GlobalSmsRateLimitQuery = {
    GetRateLimitSummary,
    GetCountryLimitByPlatform,
    GetCountryLimitHistory,
    GetCountryLimit,
};

export default GlobalSmsRateLimitQuery;

